import src from "IMAGE";
export default { src, width: 544, height: 163, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAO0lEQVR42m3IOw4AEBAA0Y0NEpvQSHxK0ajcQi9xH/dxSgo6r5sBuDTx2IqbAhnBj1HS95pXCnacxPc3aisDgDGcGoQAAAAASUVORK5CYII="};
